/* eslint-disable react/jsx-no-undef */
import { useLiff } from "react-liff";
// import { useNavigate } from "react-router-dom";
import React, { useState, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { useSelector, useDispatch, } from 'react-redux';
import TopLogo from '../../components/layout/TopLogo';
import TransparentButton from "../../components/button/TransparentButton";
import SecondaryButton from "../../components/button/SecondaryButton";
import bingobg from '../../assets/images/bingobg.png'
import bingobgNew from '../../assets/images/bingo-bg-new.png'
import { SearchBingoDetail, InsertCardActivity, InsertBingo } from "../../services/Bingo";
import bingoBanner from '../../assets/images/bingo-banner.png';
import bingoBannerNew from '../../assets/images/bingo-banner-new.png';
import uploadWhite from "../../assets/images/icon/upload-white.svg";
import uploadBlue from "../../assets/images/icon/upload-blue.svg";
import info from "../../assets/images/icon/info.svg";
import { FormControl } from "@mui/material";
import CustomPopup from "../../components/popup/CustomPopup";
import PopupBingoDetail from "../../components/popup/PopupBingoDetail";
import { setLuckyDraw } from "../../features/LuckyDrawSlice";
import useWindowDimensions from "../../functions/getScreen";


export default function BingoMain() {
  const { liff } = useLiff();
  const lineId = liff.getDecodedIDToken().sub;
  const store = useSelector((state) => state.luckyDraw)
  const bg = store['bgPicture']
  const banner = store['logoPicture']
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [bingo, setBingo] = React.useState({
    cards: []
  })
  const [image, setImage] = useState(null);
  const [isRetry, setIsRetry] = useState(false);
  const [openCancelPopup, setOpenCancelPopup] = React.useState(false);
  const popupTitle = 'รายละเอียดกิจกรรม'
  const [popupDesc, setPopupDesc] = React.useState('')
  const [type, setType] = useState(null);
  const [openErrorImagePopup, setOpenErrorImagePopup] = React.useState(false);

  const ref = useRef(null);
  const messagesEndRef = React.createRef()

  const { width } = useWindowDimensions();

  React.useEffect(() => {
    getSearchBingoDetail()
  }, []);

  async function getSearchBingoDetail() {
    // return await SearchBingoDetail({ data: { lineId: lineId, bingoId: 4 } })
    return await SearchBingoDetail({ data: { lineId: lineId, bingoId: store.campaignId } })
      .then(async (response) => {
        if (+response.data.resultCode === 20000) {
          for (let index = 0; index < response.data.body.cards.length; index++) {
            const element = response.data.body.cards[index];
            if (element.status === 'retry') {
              setIsRetry(true)
              break;
            }

          }
          setBingo(response.data.body)
          setPopupDesc(response.data.body.detail)
        }
      })
      .catch((error) => {
        console.log(error);
      });
  }

  const handleImage = (event, type) => {
    const file = event.target.files[0];
    const reader = new FileReader();
    if (event.target.files[0].size > 5242880) {
      setOpenErrorImagePopup(true)
    } else {
      reader.onloadend = () => {
        setImage(reader.result.substring(
          reader.result.indexOf(",") + 1
        ))
        setType(type)
      };
      reader.readAsDataURL(file);
    }

  };

  React.useEffect(() => {
    if (type === 'card') {
      postInsertCard()
    }
    if (type === 'bingo') {
      postInsertBingo()
    }
  }, [image]);

  async function postInsertCard() {
    const payload =
    {
      lineId: lineId,
      bingoId: bingo.bingoId,
      position: bingo.position,
      picture: image
    }
    return await InsertCardActivity({ data: payload })
      .then(async (response) => {
        if (+response.data.resultCode === 20000) {
          navigate('/bingo-success')
        }
      })
      .catch((error) => {
        console.log(error);
      });
  }

  async function postInsertBingo() {
    const payload =
    {
      lineId: lineId,
      bingoId: bingo.bingoId,
      picture: image
    }
    return await InsertBingo({ data: payload })
      .then(async (response) => {
        if (+response.data.resultCode === 20000) {
          fnSetData('isBingoUpload', true)
          navigate('/bingo-success')
        }
      })
      .catch((error) => {
        console.log(error);
      });
  }

  function fnSetData(name, value) {
    const tmpObj = {};
    tmpObj[name] = value;
    dispatch(setLuckyDraw(tmpObj));
  }

  return (
    <>
      <TopLogo />
      <div
        style={{
          background: `url(${bg}) no-repeat center center fixed`,
          // background: `url(${bingobgNew}) no-repeat center center fixed`,
          minHeight: "calc(100vh - 60px)",
          padding: "25px",
          backgroundSize: "cover"
        }}
      >
        {/* <img
          className="mx-auto mt-[30px]"
          src={bingoBanner}
          alt="logo"
          style={{ width: "233px" }}
        /> */}
        <img
          className="mt-[-25px] ml-[-25px]"
          src={banner}
          alt="logo"
          style={{ width: width, maxWidth: 'none' }}
        />

        {/* {isRetry ? (
          <div className="w-fit mx-auto flex gap-[5px] text-white font-bold text-[24px] mt-[10px]">
            <p className="text-[40px] leading-[30px] text-red">•</p>
            <p>ไม่ผ่านการตรวจสอบ กรุณาอัปโหลดใหม่</p>
          </div>
        ) : ( */}
        <div className="text-white text-center font-bold text-[24px] mt-[10px]">
          กระดานของคุณ {store['firstName']}
        </div>
        {/* )} */}

        <div className="grid grid-cols-3 gap-[2px]" style={{ margin: "auto" }}>
          {Array.isArray(bingo.cards) && bingo.cards.map((item, index) => (
            <div key={index} className="text-red">
              {
                item.status === 'success' ? (
                  <img
                    src={item.picture}
                    alt="cards"
                    style={{ width: "fit-content" }}
                  />) : item.status === 'retry' ? (
                    <div className="mb-[-8px]">
                      < button onClick={() => {
                        navigate('/bingo-detail', { state: { id: item.cardId, bingoId: bingo.bingoId, uploadPicture: bingo.uploadPicture } })
                      }}>
                        <div className="relative">
                          <div className="bg-red items-center absolute h-fit mx-[10px] left-0 right-0" style={{ borderBottomLeftRadius: "4px", borderBottomRightRadius: "4px" }}>
                            <p className="text-[16px] leading-[18px] font-bold text-white py-[3px] px-[4px]">
                              กรุณาลองใหม่
                            </p>
                          </div>
                          <img
                            src={item.picture}
                            alt="cards"
                            style={{ width: "fit-content" }}
                          />
                        </div>
                      </button>
                    </div>

                  ) : item.status === 'pending' ? (
                    <div className="mb-[-8px]">
                      < button onClick={() => {
                        navigate('/bingo-detail', { state: { id: item.cardId, bingoId: bingo.bingoId, uploadPicture: bingo.uploadPicture } })
                      }}>
                        <div className="relative">
                          <div className="bg-yellow items-center absolute h-fit mx-[10px] left-0 right-0" style={{ borderBottomLeftRadius: "4px", borderBottomRightRadius: "4px" }}>
                            <p className="text-[16px] leading-[18px] font-bold text-blue p-[3px]">
                              กำลังตรวจสอบ
                            </p>
                          </div>
                          <img
                            src={item.picture}
                            alt="cards"
                            style={{ width: "fit-content" }}
                          />
                        </div>
                      </button>
                    </div>

                  ) : (
                  <div className="mb-[-8px]">
                    <button onClick={() => {
                      navigate('/bingo-detail', { state: { id: item.cardId, bingoId: bingo.bingoId, uploadPicture: bingo.uploadPicture } })
                    }}>
                      <img
                        src={item.picture}
                        alt="cards"
                        style={{ width: "fit-content" }}
                      />
                    </button>
                  </div>

                )
              }
            </div>

          ))}
        </div>

        <div className="flex gap-[5px] text-white text-[16px] mt-[15px] w-fit ml-auto">
          <img className="w-[13px]" src={info} alt="" />
          <a onClick={(e) => {
            setOpenCancelPopup(true);
          }}
            style={{ textDecoration: "underline" }
            } >รายละเอียดกิจกรรม</a >
        </div>

        {(store['isWaiting'] || store['isBingoUpload']) &&
          <div className="mt-[50px] w-full h-[48px] items-center rounded-full" style={{
            paddingTop: '10px',
            backgroundColor: 'rgba(176, 193, 205, 1)'
          }}>
            <p style={{ color: 'rgba(109, 110, 113, 1) !important', }} className="text-[20px] text-center">อัปโหลดภาพกระดานล่าสุดแล้ว</p>
          </div>
        }

          {!store['isWaiting']  && bingo.uploadBingo  && !store['isBingoUpload'] && !store['reUpload'] &&
          <>
            <FormControl fullWidth>
              <div className="mt-[50px] w-full h-[48px] relative flex justify-center items-center gap-[5px] rounded-full border-white border-[1px]">
                <img className="w-[13px]" src={uploadWhite} alt="" />
                <p className="text-white text-[20px]">อัปโหลดภาพกระดาน</p>
                <input
                  className="opacity-0 absolute left-0 top-0 bottom-0 right-0"
                  name="urlPicture"
                  type="file"
                  accept=".jpg, .jpeg, .png"
                  onChange={(event) => handleImage(event, 'bingo')}
                />
              </div>
            </FormControl>
            <div className="text-white" style={{ fontSize: '0.8571428571428571rem' }}>* รูปต้องมีขนาดไม่เกิน 5 MB</div>
          </>
        }

        {store['reUpload'] && !store['isBingoUpload'] &&
          <>
            <FormControl fullWidth>
              <div className="mt-[50px] w-full h-[48px] relative flex justify-center items-center gap-[5px] rounded-full border-white border-[1px]">
                <img className="w-[13px]" src={uploadWhite} alt="" />
                <p className="text-white text-[20px]">อัปโหลดภาพกระดานอีกครั้ง</p>
                <input
                  className="opacity-0 absolute left-0 top-0 bottom-0 right-0"
                  name="urlPicture"
                  type="file"
                  accept=".jpg, .jpeg, .png"
                  onChange={(event) => handleImage(event, 'bingo')}
                />
              </div>
            </FormControl>
            <div className="text-white" style={{ fontSize: '0.8571428571428571rem' }}>* รูปต้องมีขนาดไม่เกิน 5 MB</div>
          </>
        }

        <CustomPopup
          title='รูปต้องมีขนาดไม่เกิน 5 MB'
          desc='กรุณาลองใหม่อีกครั้ง'
          cancelText="ปิด"
          cancelFunction={() => {
            setOpenErrorImagePopup(false);
          }}
          open={openErrorImagePopup}
        />

        <PopupBingoDetail
          title={popupTitle}
          desc={popupDesc}
          actionText="ยืนยัน"
          actionFunction={() => {
            setOpenCancelPopup(false);
          }}
          open={openCancelPopup}
          onClose={() => {
            // setOpenCancelPopup(false);
          }}
        />
      </div >
    </>
  );
}
